import type { SortingState } from '@tanstack/react-table';

export const getSWRKeyForPage =
  (path: string, pageSize: number, filters: Record<string, any>, sorters: SortingState | null, ...rest: any[]) =>
  (pageIndex: number, previousPageData: any[] | null) => {
    // if we got less than pageSize last time, there's nothing more to load
    if (previousPageData && previousPageData.length < pageSize) return null;
    // calculate the offset for the next page
    const offset = pageIndex * pageSize;
    // convert the sort array from swr to what api expects
    const sort = tableSortersToRepositorySort(sorters);
    // add the limit and offset to the filters (rest can contain any other param that should be part of the key and used by GET/POST fetchers)
    const key = [path, { ...filters, sort, limit: pageSize, offset }, ...rest];
    // console.log(`fetching limit=${pageSize} offset=${offset}`);
    return key;
  };

export const tableSortersToRepositorySort = (sorters: SortingState | null) => {
  if (!sorters || !sorters.length) return undefined;
  const result = sorters.map(({ id, desc }) => [id, desc ? 'desc' : 'asc']);
  return result;
};
